import React, { useEffect, useState } from 'react';
import { Button, Text, View } from "../../src/Components/Themed"
import type { CompanyProps, CompetitionProps, MyPlayerProps, PlayerBalanceProps } from '../../src/types';
import { useColors } from '../../src/constants/useColors';
import moment from 'moment-mini';
import { CompetitionApi } from '../../src/Competition/api';
import { Image } from 'react-native';
import { Components } from 'be-components';
import { Icons } from '../../src/Components';
import CompetitionHolder from './components/CompetitionHolder';

type CompetitionWidgetProps = {
    company:CompanyProps,
    mode:'desktop'|'mobile',
    distinct_id:string,
    layout: 'card'|'banner',
    insets: { top:number, bottom:number, left:number, right:number },
    me?:MyPlayerProps,
    my_balance?:PlayerBalanceProps,
    onShowWallet:() => void,
    onShowProfile:() => void,
    onRequestAuthenticate:() => void
}

const CompetitionWidget = ({ company, me, layout, onRequestAuthenticate, onShowProfile, onShowWallet, distinct_id, my_balance, insets, mode,  }:CompetitionWidgetProps) => {

     const Colors = useColors();
    const [ state, setState ] = useState<{
        loading:boolean,
        offset:number
        competitions:CompetitionProps[],
        comps: {
            visible:boolean,
            competition_id?:string
        }
    }>({
        loading: false,
        offset: 0,
        competitions: [],
        comps: { visible: false }
    });
    const { loading, comps, offset, competitions } = state;
    const sorted_competitions = competitions.sort((a,b) => {
        return moment(a.scheduled_datetime).unix() - moment(b.scheduled_datetime).unix()
    });
    useEffect(() => {
        CompetitionApi.setEnvironment();
        getData(company.company_id, 0);
    },[company.company_id, me?.player_id]);

    const getData = async(id:string, page:number) => {
        setState({ ...state, loading:true });
        const server_comps = await CompetitionApi.getCompetitionsByCompanyId(id, page, 'active');
        setState({
            ...state,
            loading:false,
            offset:page,
            competitions: server_comps
        });
    }


    const renderComps = (data:{ item:CompetitionProps, index:number, horizontal:boolean }) => {
        if(data.horizontal){
            return (
                <View transparent style={{ flexDirection:'row', alignItems:'center', padding:10, borderRightWidth:1, borderColor:Colors.borders.light }}>
                    <Image
                        source={{ uri: data.item.image?.url }}
                        style={{ height:35, width:35 }}
                        resizeMode='cover'
                    />
                    <View transparent style={{ width: 225, marginLeft:10, marginRight:10 }}>
                        <Text theme='h2'>{data.item.competition_name}</Text>
                        <Text theme='description' style={{ marginTop:3 }}>{data.item.competition_description}</Text>
                    </View>
                    <Button
                        type={'success'}
                        title='PLAY'
                        style={{ padding:10 }}
                        onPress={() => {
                            setState({
                                ...state,
                                comps: {
                                    visible: true,
                                    competition_id: data.item.competition_id
                                }
                            })
                        }}
                    />
                </View>
            )
        }
        return (
            <View transparent style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                <Image
                    source={{ uri: data.item.image?.url }}
                    style={{ height:40, width:40 }}
                    resizeMode='cover'
                />
                <View transparent style={{ flex:1, marginLeft:10, marginRight:10 }}>
                    <Text theme='h1'>{data.item.competition_name}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.competition_description}</Text>
                </View>
                <Button
                    type={'success'}
                    title='PLAY'
                    onPress={() => {
                        setState({
                            ...state,
                            comps: {
                                visible: true,
                                competition_id: data.item.competition_id
                            }
                        })
                    }}
                />
            </View>
        )
    }

    const renderCompetitions = () => {
        switch(layout){
            case 'banner':
                return (
                    <View transparent style={{ flex:1, flexDirection:'row' }}>
                        <View transparent style={{ padding:5, justifyContent:'center', alignItems:'center' }}>
                            <Icons.BettorEdgeIcon size={16} color={Colors.text.h1} />
                        </View>
                        <Components.AutoScrollingFlatList
                            data={sorted_competitions}
                            speed={10}
                            horizontal
                            renderItem={({ item, index }) => renderComps({ item, index, horizontal:true })}
                            key='popular_list'
                        />
                    </View>
                )
            case 'card':
                return (
                    <View float transparent style={{ flex:1, minHeight:400 }}>
                        <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                            <View transparent style={{ marginRight:10, justifyContent:'center', alignItems:'center' }}>
                                <Icons.BettorEdgeIcon size={16} color={Colors.text.h1} />
                            </View>
                            <View transparent style={{ flex:1, padding:5 }}>
                                <Text theme='h1'>Competitions</Text>
                                <Text theme='description' style={{ marginTop:3 }}>Play pick-em / wager based competitions powered by BettorEdge</Text>
                            </View>
                        </View>
                        <View transparent type='body' style={{ flex:1 }}>
                            <Components.AutoPageFlatList
                                time_on_page={10}
                                itemHeight={110}
                                reset_key={'NONE'}
                                data={sorted_competitions}
                                renderItem={({ item, index }) => renderComps({ item, index, horizontal: false })}
                            />
                        </View>
                    </View>
                )
            default: return <></>
        }
    }

    return (
        <View style={{ flex:1 }}>
            {renderCompetitions()}
            <CompetitionHolder
                me={me}
                company={company}
                onRequestAuthenticate={onRequestAuthenticate}
                onShowProfile={onShowProfile}
                onShowWallet={onShowWallet}
                distinct_id={distinct_id}
                insets={insets}
                onRequestLocation={() => console.log('')}
                mode={mode}
                onClose={() => setState({ ...state, comps: { visible: false } })}
                my_balance={my_balance}
                competition_id={comps.competition_id}
                visible={comps.visible}

            />    
        </View>
        
    )
}

export default CompetitionWidget